import { O } from '@angular/cdk/overlay-module.d-B3qEQtts';
import { Component, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppService } from 'src/app/app.service';
import { CompanyService } from 'src/app/company/company.service';
import { Role } from 'src/app/shared/models/user-model';
import { OperatorInput } from '../prf-template-upload-progress/operators/models/models';
import { PrfTemplateUploadProgressComponent } from '../prf-template-upload-progress/prf-template-upload-progress.component';
import { DownloadPrfTemplatePopupComponent } from '../download-prf-template-popup/download-prf-template-popup.component';
import { PrfTemplateDownloadService } from '../download-prf-template-popup/prf-template-download.service';

@Component({
  selector: 'app-create-prf-from-file-popup',
  templateUrl: './create-prf-from-file-popup.component.html',
  styleUrls: ['./create-prf-from-file-popup.component.scss'],
  standalone: false
})
export class CreatePrfFromFilePopupComponent {
  @Input() prfyear!: number;
  selectedFile: File | null = null;
  invalidFileMessage = '';
  isUploadInProgress = false;
  showCloseConfirm = false;
  isDownloadingTemplate = false;
  operatorInput: OperatorInput;

  @ViewChild(PrfTemplateUploadProgressComponent) uploadProgressComp: PrfTemplateUploadProgressComponent;

  constructor(
    public activeModal: NgbActiveModal,
    private readonly companyService: CompanyService,
    private readonly router: Router,
    private readonly modalService: NgbModal,
    private readonly appService: AppService,
    private readonly templateDownloadService: PrfTemplateDownloadService
  ) {}

  requestClose(): void {
    if (this.isUploadInProgress && !this.uploadProgressComp?.isComplete) {
      this.showCloseConfirm = true;
    } else {
      this.activeModal.dismiss('Cross click');
    }
  }

  confirmClose(): void {
    this.activeModal.dismiss('Cross click');
  }

  cancelClose(): void {
    this.showCloseConfirm = false;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0] ?? null;

    if (!file || !this.isExcelFile(file.name)) {
      this.selectedFile = null;
      this.invalidFileMessage = 'Invalid file selected. Please upload an Excel file (.xls or .xlsx).';
      if (input) {
        input.value = '';
      }
      return;
    }

    this.invalidFileMessage = '';
    this.isUploadInProgress = false;
    this.selectedFile = file;
    this.operatorInput = {
      file: file,
      prfyear: this.prfyear,
      prfCreated: false
    };
  }

  uploadFile(): void {
    if (!this.selectedFile) {
      return;
    }

    this.isUploadInProgress = true;
  }

  downloadPrfTemplate(): void {
    // Customers can only get the group specific template, so download it directly
    // (using their group from local storage) without showing the selection popup.
    if (this.appService.hasRole(Role.Customer)) {
      this.downloadGroupTemplateForCustomer();
      return;
    }

    const modalRef = this.modalService.open(DownloadPrfTemplatePopupComponent, {
      windowClass: 'download-template-modal-window',
      backdropClass: 'download-template-modal-backdrop',
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.prfyear = this.prfyear;
  }

  private downloadGroupTemplateForCustomer(): void {
    if (this.isDownloadingTemplate) {
      return;
    }
    const groupcode = localStorage.getItem('groupcode') ?? '';
    if (!groupcode) {
      return;
    }
    this.isDownloadingTemplate = true;
    this.templateDownloadService
      .downloadGroupTemplate(this.prfyear, groupcode)
      .then(() => {
        this.isDownloadingTemplate = false;
      })
      .catch(() => {
        this.isDownloadingTemplate = false;
        this.router.navigate(['/apifailure']);
      });
  }

  private isExcelFile(fileName: string): boolean {
    const fileExtension = fileName.split('.').pop()?.toLowerCase();
    return fileExtension === 'xls' || fileExtension === 'xlsx';
  }
}
